'use client';
import React from 'react';
import { Box, Button, Flex, Link, Text } from '@skin-seoul/design-system';

interface LoyaltySignUpBannerDesktopProps {
  titleLine2?: string;
}

export const LoyaltySignUpBannerDesktop = ({ titleLine2 = 'SkinSociety' }: LoyaltySignUpBannerDesktopProps) => {
  return (
    <Box
      position="relative"
      width="100%"
      height="112px"
      borderRadius="8px"
      bgGradient="to-tl"
      gradientFrom="#311275"
      gradientTo="#754DCC"
      overflow="hidden"
    >
      <Flex
        position="relative"
        height="100%"
        alignItems="center"
        justifyContent="space-between"
        pl={4}
        pr={6}
        py={4}
        zIndex={1}
      >
        {/* Left Side - Title and Subtitle */}
        <Flex direction="column" gap={2}>
          <Flex direction="column" gap={0}>
            <Text as="span" color="primary.100" textStyle="heading.h6" fontWeight="bold">
              Join {titleLine2}
            </Text>
            <Text as="span" color="primary.100" textStyle="heading.h6" fontWeight="bold">
              & Start Earning
            </Text>
          </Flex>
          <Text color="primary.100" textStyle="label.small">
            Sign up to earn rewards
          </Text>
        </Flex>

        {/* Right Side - Sign Up Button */}
        <Button
          asChild
          size="md"
          variant="primary"
          bg="white"
          color="neutral.800"
          _hover={{ bg: 'neutral.50' }}
          px={6}
          height="44px"
        >
          <Link unstyled href="/my-account/">
            Sign Up
          </Link>
        </Button>
      </Flex>
    </Box>
  );
};
